import { LocaleCode } from './locales';

/** 独立设计师页面默认使用中文；支持宿主显式注入英文 */
export const CLIENT_LOCALE: LocaleCode = window.__LOCALE__ === 'en' ? 'en' : 'zh-Hans';
